import { TFunction } from '@lyearn/i18n';
import TagsFiltersList, {
  isTagPillSelected,
} from '@/components/Filters/NestedFilter/NestedFilterPill/tagFilters';

import { FilterManager, NestedItem } from '../../types';
import { TagsQueryParams } from './types';
import { TagsEntityConfig } from '.';

export const tagsFilterConfig = (
  t: TFunction,
  isNonEditableIds?: string[],
): NestedItem<TagsQueryParams> => ({
  type: FilterManager.Nested,
  id: 'tagFilters',
  defaultPlaceholder: t('Common:Filter.AddFilter'),
  isEnabled: true,
  listConfig: TagsEntityConfig,
  headerProps: {
    label: t('Common:Form.Tags'),
  },
  pillsConfig: [
    {
      id: 'tagFilters',
      Component: (props) => {
        return <TagsFiltersList id="tagFilters" {...props} isNonEditableIds={isNonEditableIds} />;
      },
      isPillSelected: isTagPillSelected,
    },
  ],
});
